import JsEncrypt from 'jsencrypt'
import { KJUR, KEYUTIL, hex2b64 } from 'jsrsasign'
import Vue from 'vue'
import { Message } from 'element-ui'
var RSAEncrypt = {
  // 公钥
  publicKey: `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCCKz5pteMUwZ5vPxswRWwp7uZZTk/nSU1XUwcegtoP5OmTe+DJ3BAFRhMSlOFnApA3GW20yach4Wh3LEH1CIXLZUeKNjxsz0Ha0gV9pgZjEZMrTGCA0hpfoJfrk8l4J/tV+71aZVZ67rw86Xc4zLAmKDRFoNq4ex6tv+RPLlSwDwIDAQAB
  -----END PUBLIC KEY-----`,
  // 私钥
  privateKey: `-----BEGIN PRIVATE KEY-----
  MIICdgIBADANBgkqhkiG9w0BAQEFAASCAmAwggJcAgEAAoGBAIIrPmm14xTBnm8/GzBFbCnu5llOT+dJTVdTBx6C2g/k6ZN74MncEAVGExKU4WcCkDcZbbTJpyHhaHcsQfUIhctlR4o2PGzPQdrSBX2mBmMRkytMYIDSGl+gl+uTyXgn+1X7vVplVnruvDzpdzjMsCYoNEWg2rh7Hq2/5E8uVLAPAgMBAAECgYAaH1OHI1lO8Qw6hw+NwGDUiXzwryaZ47wBqkfjd58LUYUOc+3IlMEiTc3GDNqvMXR/mjrJ7S39Pp8YS2lxIyS2QYzdijYUyWEopeOCv1mmykZ/qmp1xp1pdKs6fxKJApA3JFR257T+jqImgHrY3xEfbQWDyhZ6IK6UX63rwgKiAQJBAOVj73io+jRvcq86GeIQiZB1pF6NWMZRGBix2OtL5ije5H9qJW9poHk4t+I64l7Dzcy2tuIONok4S+yR+KT44UkCQQCRRMpAnq3Ju6Hs/ayV8B/P9he6jWQh1gwBlC58oskFeMAwu1Gv7pmcHjQA+xDJSm2SNPoyw7SRzu0SL9uFV16XAkA4IAqAqD+Hwtj5nKqmkEtISDBuXgEhjMfriuA7OffXeinILw13xA1ae5EqTiQC8b+R3gbDKp0XV+njuRdwLeDZAkAZ3z6GM7yP6TL1mlhae+GukA250+S5gf2xakq9N+DFcLQJ+dKamswQ2fA5HH3o27CYEYdd8yz9qvTeAFgAb4cRAkEAw7A56BWptv5DzFgCuQnogRHXRqfJTXJybuNB7HE+GqsjFpElkVhIUrneR1lRLY7oGW9NgKOX+ioksLS4Zu2z8Q==
  -----END PRIVATE KEY-----
  `,
  // 签名算法
  ALGORITHM: 'SHA256withRSA',
  encrypt: function(data) {
    const jse = new JsEncrypt()
    jse.setPublicKey(this.publicKey)
    if (typeof (data) === 'object') {
      data = JSON.stringify(data)
    }
    const result = jse.encrypt(data)
    if (typeof (result) === 'boolean') {
      if (!result) {
        Message({
          message: '公钥不正确,请核对！',
          type: 'warning'
        })
        return null
      }
    }
    return result
  },
  decrypt: function(data) {
    if (typeof (data) !== 'string') {
      Message({
        message: '加密数据不正确,请核对！',
        type: 'warning'
      })
      return null
    }
    const jse = new JsEncrypt()
    jse.setPrivateKey(this.privateKey)
    if (typeof (data) === 'object') {
      data = JSON.stringify(data)
    }
    const result = jse.decrypt(data)
    return result
  },
  // 私钥签名
  rsaSign: function(plaintext) {
    const signature = new KJUR.crypto.Signature({ 'alg': this.ALGORITHM })
    // 来解析密钥
    const priKey = KEYUTIL.getKey(this.privateKey)
    signature.init(priKey)
    // 传入待签明文
    signature.updateString(plaintext)
    const a = signature.sign()
    // 转换成base64，返回
    return hex2b64(a)
  },
  paramSign(config) {
    var encryptParams = config.params
    var method = config.method
    if (method === 'get') {
      if (config.params != null) {
        encryptParams = config.params
      } else {
        encryptParams = {}
      }
    }
    if (method === 'post') {
      if (config.data != null) {
        encryptParams = config.data
      } else {
        encryptParams = {}
      }
    }
    const KEY = '0f80748'
    const values = []
    if (typeof (encryptParams) === 'object') {
      if (Object.prototype.toString.call(encryptParams) === '[object Array]') {
        encryptParams.forEach((item) => {
          if (typeof (item) === 'object') {
            for (const encryptParam in item) {
              if (item[encryptParam] !== undefined) {
                values.push(item[encryptParam])
              }
            }
          } else {
            values.push(item)
          }
        })
      } else {
        for (const encryptParam in encryptParams) {
          if (encryptParams[encryptParam] !== undefined) {
            values.push(encryptParams[encryptParam])
          }
        }
      }
    } else {
      if (encryptParams !== undefined) {
        values.push(encryptParams)
      }
    }
    values.sort()
    values.push(KEY)

    let s = ''
    values.forEach(function(v, i) {
      if (v !== null) {
        s = s + (v) + ''
      }
    })
    // console.log('参与加密参数:' + s)
    return this.rsaSign(s)
  }
}

Vue.prototype.RSAEncrypt = RSAEncrypt
export default RSAEncrypt
